export type CourtTemporaryBlockadeDto = {
  id: string;
  startTime: string;
  endTime: string;
  reason: CourtTemporaryBlockadeReason;
  description?: string;
  courtId?: number;
};

export enum CourtTemporaryBlockadeReason {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  COURT_MAINTENANCE = 'COURT_MAINTENANCE',
  EXTERNAL_RESERVATION = 'EXTERNAL_RESERVATION',
  OTHER = 'OTHER',
}
